/* eslint-disable jsx-a11y/label-has-associated-control */
import { useRef } from 'react';

import { useIntl } from 'react-intl';

import useAutosizeTextArea from './useAutosizeTextArea';

import { ChatTextBoxProps } from './types';

import * as S from './styles';

const MAX_CHARACTERS = 4000; // https://www.twilio.com/docs/conversations/conversations-limits Max Chat: 32kb = 4096 chars

export const ChatTextBox: React.FC<ChatTextBoxProps> = ({
  value,
  onChange,
}) => {
  const intl = useIntl();

  const textAreaRef = useRef<HTMLTextAreaElement>(null);

  const placeholder = intl.formatMessage({ id: 'CHAT.FOOTER.PLACEHOLDER' });

  useAutosizeTextArea(textAreaRef.current, value);

  return (
    <S.TextBox
      rows={1}
      spellCheck
      value={value}
      ref={textAreaRef}
      onChange={onChange}
      placeholder={placeholder}
      maxLength={MAX_CHARACTERS}
    />
  );
};
export default ChatTextBox;
